<template>
  <v-container fluid class="p-3" style="padding-bottom:10px">
    <v-row>
      <v-col cols="12">
        <v-snackbar v-model="snackbar.visible" :color="snackbar.color" :timeout="snackbar.timeout" :top="snackbar.position === 'top'">
          <v-layout align-center pr-4>
            <v-icon class="pr-3" dark large>{{ snackbar.icon }}</v-icon>
            <v-layout column>
              <div><strong>{{ snackbar.title }}</strong></div>
              <div>{{ snackbar.text }}</div>
            </v-layout>
          </v-layout>
          <v-btn v-if="snackbar.timeout === 0" icon @click="snackbar.visible = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-snackbar>
      </v-col>
    </v-row>
    <v-card class="mb-2 rounded-lg" flat>
      <div class="d-flex align-center flex-wrap px-4 py-2"
        style="gap:10px; background: linear-gradient(to right, rgba(63, 81, 181, 0.1), rgba(33, 150, 243, 0.1))">
        <v-icon small color="primary" class="mr-1">mdi-sitemap</v-icon>
        <span class="text-subtitle-2 font-weight-medium primary--text">Key Performance Indicator Setup — Chart View</span>
        <v-spacer></v-spacer>
        <v-btn small color="success" @click="create" :disabled="isUser" class="text-none" depressed rounded>
          <v-icon size="18" class="mr-1">mdi-account-plus</v-icon>
          Setup New Position
        </v-btn>
        <v-btn small color="primary" @click="openPeriodDialog" :disabled="isUser" class="text-none" depressed rounded>
          <v-icon size="18" class="mr-1">mdi-calendar-clock</v-icon>
          Setup Period Entity
        </v-btn>
      </div>
    </v-card>
    <v-col class="mt-4">
      <v-row>
        <v-col cols="12">
          <v-card
            v-if="isChartEmpty"
            elevation="2"
            rounded="lg"
            class="pa-8 text-center"
            style="background: linear-gradient(145deg, #ffffff 0%, #f5f5f5 100%); border: 2px solid transparent; border-image: linear-gradient(45deg, #3f51b5, #2196f3) 1;"
          >
            <v-icon
              size="80"
              color="grey lighten-1"
              class="mb-6"
            >
              mdi-account-group-outline
            </v-icon>
            <v-card-text class="text-h5 grey--text text--darken-1 font-weight-medium">
              No organization chart structure available for this entity.
            </v-card-text>
            <v-card-subtitle class="mt-3 text-subtitle-1 grey--text">
              Please create a new position or contact administrator
            </v-card-subtitle>
          </v-card>
           <v-card
            v-else
            class="pa-6 rounded-lg chart-container"
            elevation="3"
            style="background: linear-gradient(145deg, #ffffff 0%, #f5f5f5 100%); border: 2px solid transparent; border-image: linear-gradient(45deg, #3f51b5, #2196f3) 1;"
          >
            <div id="tree" class="org-chart-wrapper"></div>
          </v-card>
        </v-col>
        <Newuser
          v-model="dialognewuser"
          :selected-node="selectedNode"
          :users="users"
          :report-to-list="reportToList"
        />
        <Edituser
          v-model="dialogedituser"
          :selected-node="selectedNode"
          :users="users"
          :report-to-list="reportToList"
          @open-detail="openDetail"
          @close-dialog="resetNodeColors"
          @submitted="refreshDataAfterEdit"
          @snackbar="showSnackbar"
          @update-selected-node="updateSelectedNode"
        />
        <Detail
          v-model="dialogdetailuser"
          :kpi-data="kpiData"
          :owners="owners"
          :sharing-options="sharingOptions"
          :calc-options="calcOptions"
          :ver-options="verOptions"
          :higher-lower-options="higherLowerOptions"
          :selected-node="selectedNode"
          :selected-period="selectedPeriod"
          @add-owner-set="addOwnerSet"
          @add-kpi-data="addKpiData"
          @remove-owner-set="removeOwnerSet"
          @remove-all-kpi="removeAllset"
          @show-snackbar="showSnackbar"
          @kpi-item-data-loaded="handleKpiItemDataLoaded"
          @kpi-item-deleted="handleKpiDeleted"
        />
      </v-row>
    </v-col>
    <v-dialog v-model="deleteDialog" max-width="400px">
      <v-card class="rounded-lg">
        <v-card-title class="headline error--text pa-4">
          <v-icon left color="error" large>mdi-alert-circle</v-icon>
          Confirm Delete
        </v-card-title>
        <v-card-text class="pa-4 text-subtitle-1">
          Are you sure you want to delete this User? This action cannot be undone.
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn 
            color="grey darken-1" 
            text 
            class="text-capitalize rounded-lg"
            @click="deleteDialog = false"
          >
            Cancel
          </v-btn>
          <v-btn 
            color="error"
            class="text-capitalize rounded-lg"
            @click="confirmDelete"
          >
            <v-icon left>mdi-delete</v-icon>
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="deletePeriodDialog" max-width="400px">
      <v-card class="rounded-lg">
        <v-card-title class="headline error--text pa-4">
          <v-icon left color="error" large>mdi-alert-circle</v-icon>
          Confirm Delete Period
        </v-card-title>
        <v-card-text class="pa-4 text-subtitle-1">
          Are you sure you want to delete this period? This action cannot be undone.
          <div class="mt-3" v-if="periodToDelete">
            <strong>Period:</strong> {{ formatDate(periodToDelete.start_date) }} - {{ formatDate(periodToDelete.end_date) }}
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn 
            color="grey darken-1" 
            text 
            class="text-capitalize rounded-lg"
            @click="deletePeriodDialog = false"
          >
            Cancel
          </v-btn>
          <v-btn 
            color="error"
            class="text-capitalize rounded-lg"
            @click="deletePeriodConfirmed"
          >
            <v-icon left>mdi-delete</v-icon>
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showAddPeriodModal" max-width="800px" persistent>
      <v-card class="rounded-lg">
        <v-card-title class="headline darken-1 white--text py-4 px-6 rounded-t-lg" style="background-color:#1f415d;">
          <v-icon left color="white">mdi-calendar-plus</v-icon>
          <span class="text-h6">Add New Period</span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closeAddPeriodModal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-6">
          <v-form ref="periodForm">
            <v-row>
              <v-col cols="12" md="6">
                <v-menu
                  ref="startDateMenu"
                  v-model="startDateMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="newPeriod.start_month"
                      label="Start Date"
                      prepend-inner-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                      outlined
                      dense
                      readonly
                      hide-details="auto"
                      class="rounded-lg"
                      :rules="[v => !!v || 'Start date is required']"
                    />
                  </template>
                  <v-date-picker
                    v-model="newPeriod.start_month"
                    no-title
                    type="month"
                    color="primary"
                    @input="startDateMenu = false"
                    class="rounded-lg"
                  />
                </v-menu>
              </v-col>
              <v-col cols="12" md="6">
                <v-menu
                  ref="endDateMenu"
                  v-model="endDateMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="newPeriod.end_month"
                      label="End Date"
                      prepend-inner-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                      outlined
                      dense
                      readonly
                      hide-details="auto"
                      class="rounded-lg"
                      :rules="[v => !!v || 'End date is required', validateEndDate]"
                    />
                  </template>
                  <v-date-picker
                    v-model="newPeriod.end_month"
                    no-title
                    type="month"
                    color="primary"
                    @input="endDateMenu = false"
                    class="rounded-lg"
                  />
                </v-menu>
              </v-col>
              <v-col cols="12" class="pt-4">
                <v-card outlined class="rounded-lg">
                  <v-card-title class="py-3 px-6 grey lighten-4">
                    <span class="text-h6 font-weight-medium">Period List</span>
                  </v-card-title>
                  <v-data-table
                    :headers="[
                      { text: 'Start Date', value: 'start_month', align: 'center' },
                      { text: 'End Date', value: 'end_month', align: 'center' },
                      { text: 'Actions', value: 'actions', align: 'center', sortable: false }
                    ]"
                    :items="periodList"
                    :items-per-page="10"
                    class="elevation-0"
                  >
                  <template #[`item.actions`]="{ item }">
                    <v-btn
                      v-if="item.is_active === 0"
                      small
                      color="grey darken-1"
                      :loading="loadingSetActive"
                      @click="setActivePeriode(item)"
                      class="mr-2 text-white rounded-lg px-4"
                      elevation="1"
                    >
                      NON-Active
                    </v-btn>
                    <v-btn
                      v-else
                      small
                      color="success"
                      text-color="white"
                      class="mr-2 text-none rounded-lg px-4"
                      elevation="1"
                    >
                      KPI-Active
                    </v-btn>
                    <v-btn
                      small
                      color="error"
                      @click="deletePeriode(item)"
                      class="text-none rounded-lg px-4"
                      elevation="1"
                    >
                      <v-icon left>mdi-delete</v-icon>
                      Delete
                    </v-btn>
                  </template>
                    <template v-slot:no-data>
                      <div class="text-center grey--text py-4">
                        No periods added yet
                      </div>
                    </template>
                  </v-data-table>
                </v-card>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-6">
          <v-spacer></v-spacer>
          <v-btn
            text
            color="grey darken-1"
            @click="closeAddPeriodModal"
            :disabled="addingPeriod"
            class="text-capitalize rounded-lg mr-3"
          >
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            @click="addPeriod"
            :loading="addingPeriod"
            :disabled="addingPeriod"
            class="text-capitalize rounded-lg px-6"
            elevation="2"
          >
            <v-icon left>mdi-plus</v-icon>
            Add Period
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="deleteConfirmDialog" max-width="500px" persistent>
      <v-card>
        <v-card-title class="headline red--text">
          <v-icon color="red" class="mr-2">mdi-alert-circle</v-icon>
          Konfirmasi Hapus
        </v-card-title>
        
        <v-card-text class="pt-4">
          <div class="text-body-1">
            Apakah Anda yakin ingin menghapus KPI Ini ?
          </div>    
          <div class="mt-3 text-caption red--text">
            <v-icon small color="red" class="mr-1">mdi-information</v-icon>
            Tindakan ini tidak dapat dibatalkan.
          </div>
        </v-card-text>
        
        <v-card-actions>
          <v-spacer></v-spacer>
          
          <v-btn 
            color="grey" 
            text 
            @click="cancelDeleteOwnerSet"
          >
            <v-icon left>mdi-close</v-icon>
            Batal
          </v-btn>
          
          <v-btn 
            color="red"
            class="text-white"
            @click="confirmDeleteKpi"
          >
            <v-icon left>mdi-delete</v-icon>
            Hapus
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import Detail from "./Detail.vue";
import Newuser from "./Newuser.vue";
import Edituser from "./Edituser.vue";

export default {
	components: {
		Detail,
		Newuser,
		Edituser,
	},

	data() {
		return {
			deleteDialog: false,
			selectedPeriod: null,
			showSettingKpiButton: false,
			periodList: [],
			deletePeriodDialog: false,
			periodToDelete: null,
			showAddPeriodModal: false,
			startDateMenu: false,
			endDateMenu: false,
			addingPeriod: false,
			deleteConfirmDialog: false,
			deleteOwnerSetData: null,
			loadingSetActive: false,
			settingKpiLoading: {},
			newPeriod: {
				start_month: "",
				end_month: "",
			},
			showPeriodeListModal: false,
			periodeListData: [],
			loadingPeriodeList: false,
			snackbar: {
				color: null,
				icon: null,
				mode: null,
				position: "top",
				text: null,
				timeout: 7500,
				title: null,
				visible: false,
			},
			selectedPeriod: null,
			localUsers: [],
			localReportToList: [],
			users: [],
			reportToList: [],
			changedItems: [],
			isChartEmpty: false,
			dialog: false,
			isLoading: false,
			dialognewuser: false,
			dialogdetailuser: false,
			dialogedituser: false,
			selectedNode: {
				name: "",
				notes: "",
				assignUser: null,
				reportTo: null,
			},
			nodes: [],
			owners: ["02.3. Admin NPD", "02.2. Sales Manager"],
			sharingOptions: ["A", "B", "C"],
			calcOptions: ["Sum", "Average", "Max", "Last"],
			verOptions: [
				{ text: "Sum", value: "Sum" },
				{ text: "Average", value: "Average" },
			],
			higherLowerOptions: ["higher", "lower"],
			kpiData: [],
		};
	},

	watch: {
		"entity.id": {
			async handler(newVal, oldVal) {
				if (newVal && newVal !== oldVal) {
					await this.$store.dispatch("setOverlay", true);
					await this.delay(1000);
					await this.loadChartByEntity();
					await this.$store.dispatch("setOverlay", false);
				}
			},
			immediate: true,
		},
		dialogedituser(newVal, oldVal) {
			if (oldVal === true && newVal === false) {
				this.refreshDataAfterEdit();
			}
		},
		selectedPeriod: {
			handler(newPeriod, oldPeriod) {
				if (newPeriod && oldPeriod && newPeriod.id !== oldPeriod.id) {
					this.kpiData = [];
				} else if (newPeriod && !oldPeriod) {
					this.kpiData = [];
				}
			},
			deep: true,
		},
	},

	computed: {
		user() {
			return this.$store.getters.getUser;
		},
		entity() {
			return this.$store.state.entity;
		},
		isUser() {
			return this.user?.role === "user";
		},
		hasActivePeriod() {
			return this.selectedPeriod && this.selectedPeriod.is_active === 1;
		},
	},

	mounted() {
		this.loadChartByEntity();
		if (this.$route.query.openDetail && this.$route.query.chartId) {
			this.selectedPeriod = {
				id: this.$route.query.kpiPeriodeId,
				is_active: 1,
			};

			this.loadChartAndOpenModal(this.$route.query.chartId);

			this.$router.replace({ query: {} });
			return;
		} else {
			this.loadChartByEntity();
		}
	},

	methods: {
		async loadChartAndOpenModal(chartId) {
			try {
				const response = await this.$axios.get(
					`${process.env.VUE_APP_URL}/api/kpi-item/owner/${chartId}`,
					{
						headers: {
							Authorization: `Bearer ${this.$store.getters.isTokenUser}`,
						},
					}
				);

				const ownerData = response.data;

				if (ownerData && ownerData.length > 0) {
					const owner = ownerData[0];
					const userName =
						owner.user_name ||
						owner.name ||
						owner.user?.name ||
						owner.username ||
						owner.full_name ||
						owner.display_name ||
						(owner.user && owner.user.full_name) ||
						"User Not Available";
					this.selectedNode = {
						id: chartId,
						name: owner.position_name || "Unknown Position",
						title: userName,
						position_name: owner.position_name,
						user_name: userName,
						chart_id: chartId,
						user: {
							name: userName,
						},
					};
				} else {
					console.warn("⚠️ No owner data found");
					this.selectedNode = {
						id: chartId,
						name: "Position Not Found",
						title: "User Not Found",
						chart_id: chartId,
					};
				}

				this.dialogdetailuser = true;
			} catch (error) {
				console.error("❌ Error loading owner data:", error);
				this.selectedNode = {
					id: chartId,
					name: "Chart " + chartId,
					title: "User " + chartId,
					chart_id: chartId,
				};

				this.dialogdetailuser = true;
			}
		},
		async loadChartByEntity() {
			if (!this.$store.getters.isTokenUser || !this.entity?.id) return;

			try {
				const res = await this.$axios.get(
					`${process.env.VUE_APP_URL}/api/charts`,
					{
						headers: {
							Authorization: `Bearer ${this.$store.getters.isTokenUser}`,
						},
						params: {
							entity_id: this.entity.id,
						},
					}
				);
				const rawData = res.data;
				function mapChartData(data) {
					return data.map((item) => {
						const kelas =
							item.status_publish === 1
								? "node-green"
								: item.status_publish === 2
								? "node-orange"
								: "node-gray";
						const vacant = !item.user ? " node-vacant" : "";

						return {
							...item,
							name: item.position_name,
							title: item.user ? item.user.name : "User Tidak Isi !",
							className: kelas + vacant,
							children: item.children ? mapChartData(item.children) : [],
						};
					});
				}

				const chartDataArray = mapChartData(rawData);
				if (!chartDataArray.length) {
					this.isChartEmpty = true;
					$("#tree").empty();
					return;
				}
				this.isChartEmpty = false;

				const chartData = chartDataArray[0];

				this.$nextTick(() => {
					const $tree = $("#tree");
					$tree.off("wheel");
					if ($tree.data("orgchart")) {
						$tree.orgchart("destroy");
					}
					$tree.empty();
					$tree.orgchart({
						data: chartData,
						nodeContent: "title",
						pan: true,
						zoom: true,
						zoominLimit: 7,
						zoomoutLimit: 0.5,
						verticalLevel: 1,
						createNode: ($node, data) => {
							$node.on("click", async () => {
								try {
									this.$store.dispatch("setOverlay", true);
									$(".selected-node").removeClass("selected-node");
									$node.addClass("selected-node");
									this.selectedNode = data;
									this.showSettingKpiButton = true;
									await this.getAllChartFilters();
									await this.getShowUser();

									this.dialogedituser = true;
								} catch (error) {
								} finally {
									this.$store.dispatch("setOverlay", false);
								}
							});
						},
					});
				});
			} catch (error) {
				console.error("❌ Gagal load chart:", error);
			}
		},
		delay(ms) {
			return new Promise((resolve) => setTimeout(resolve, ms));
		},
		async getAllChartFilters() {
			const [userResp, positionResp] = await Promise.all([
				this.$axios.get(`${process.env.VUE_APP_URL}/api/charts/users-list`, {
					headers: {
						Authorization: `Bearer ${this.$store.getters.isTokenUser}`,
					},
				}),
				this.$axios.get(`${process.env.VUE_APP_URL}/api/charts/position-list`, {
					headers: {
						Authorization: `Bearer ${this.$store.getters.isTokenUser}`,
					},
				}),
			]);

			if (userResp.status === 200) {
				this.users = userResp.data.users.map((u) => ({
					text: u.name,
					value: u.id,
					...u,
				}));
			}

			if (positionResp.status === 200) {
				this.reportToList = positionResp.data.positions.map((p) => ({
					text: p.position_name,
					value: p.id,
					...p,
				}));
			}
		},
		async getShowUser() {
			const res = await this.$axios.get(
				`${process.env.VUE_APP_URL}/api/charts/detail/${this.selectedNode.id}`,
				{
					headers: {
						Authorization: `Bearer ${this.$store.getters.isTokenUser}`,
					},
				}
			);
			const detail = res.data;
			const assignedUser = detail.user
				? {
						text: detail.user.name,
						value: detail.user.id,
						...detail.user,
				  }
				: null;
			if (
				assignedUser &&
				!this.users.find((u) => u.value === assignedUser.value)
			) {
				this.users.unshift(assignedUser);
			}
			this.selectedNode = {
				...this.selectedNode,
				...detail,
				user_id: assignedUser?.value ?? null,
				chart_parent_id: detail?.chart_parent_id ?? null,
				position_name: detail?.position_name ?? "",
				position_description: detail?.position_description ?? "",
			};
		},
		showSnackbar(options) {
			this.snackbar = {
				...this.snackbar,
				...options,
				visible: true,
			};
		},
		create() {
			this.dialognewuser = true;
			this.getAllChartFilters();
		},
		resetNodeColors() {
			document.querySelectorAll("[data-n-id]").forEach((el) => {
				el.classList.remove("selected-node");
			});
		},
		updateSelectedNode(data) {
			this.selectedNode = { ...this.selectedNode, ...data };
		},

		handleKpiItemDataLoaded(data) {
			if (data.formattedSharingOptions) {
				this.sharingOptions = data.formattedSharingOptions;
			}
			if (data.formattedOwners) {
				this.owners = data.formattedOwners;
			}

			if (data.formattedSharingOptions) {
				this.sharingOptions = data.formattedSharingOptions;
			}
			this.kpiData = [];
			const kpiItems = data.kpiData || [];
			kpiItems.forEach((item) => {
				const kpiItem = {
					id: item.id,
					kpi_periode_id: item.kpi_periode_id,
					chart_id: item.chart_id,
					manualAdjustment: Boolean(item.manual_adjustment),
					isAccounting: Boolean(item.is_accounting),
					kpiName: item.kpi_name || "",
					sharing: this.convertShares(item.shares) || [],
					unit: this.getUnitText(item.unit_id),
					kalkulasi: this.getCalculationText(item.kalkulasi_id),
					vertikal: this.getVerticalText(item.vertical_id),
					bobot: item.bobot,
					status_kpi: item.status_kpi,
					owner_position_name: item.owner_position_name,
					owner_name: item.owner_name,
					nomor: item.nomor,
					ownerSets: [],
				};

				kpiItem.ownerSets.push({
					kpi_item_id: item.id,
					owner: item.owner_id || "",
					sharing: this.convertShares(item.shares) || [],
					manualAdjustment: Boolean(item.manual_adjustment),
					isAccounting: Boolean(item.is_accounting),
					pengukuran: item.pengukuran || "",
					kpiName: item.kpi_name || "",
					sumberData: item.sumber_data || "",
					annualTarget: item.annual_target || "",
					higherLower: item.direction || "",
					checked: Boolean(item.manual_adjustment),
					bobot: item.bobot,
				});
				if (
					item.children &&
					Array.isArray(item.children) &&
					item.children.length > 0
				) {
					item.children.forEach((child) => {
						const childOwnerSet = {
							kpi_item_id: child.id,
							owner: child.owner_id || "",
							sharing: this.convertShares(child.shares) || [],
							pengukuran: child.pengukuran || "",
							isAccounting: Boolean(child.is_accounting),
							kpiName: child.kpi_name || "",
							sumberData: child.sumber_data || "",
							annualTarget: child.annual_target || "",
							higherLower: child.direction || "",
							checked: Boolean(child.manual_adjustment),
							bobot: child.bobot,
							owner_position_name: child.owner_position_name,
							owner_name: child.owner_name,
						};
						kpiItem.ownerSets.push(childOwnerSet);
					});
				}

				this.kpiData.push(kpiItem);
			});
		},
		getUnitText(unitId) {
			const unitMap = {
				1: "%",
				2: "Rp",
				3: "Unit",
			};
			return unitMap[unitId] || "";
		},
		getCalculationText(calculationId) {
			const calcMap = {
				1: "Sum",
				4: "Last",
				3: "Max",
				2: "Average",
			};
			return calcMap[calculationId] || "";
		},
		openDetail(payload = null) {
			let chartData, periodData;

			if (payload && payload.chart_id) {
				chartData = payload.chart_data;
				periodData = payload.period_data;
			} else {
				chartData = this.selectedNode;
				periodData = this.selectedNode?.active_period || this.selectedPeriod;
			}
			if (!chartData) {
				this.showSnackbar({
					color: "warning",
					text: "No chart selected. Please select a chart first.",
				});
				return;
			}
			if (!periodData && this.selectedPeriod) {
				periodData = this.selectedPeriod;
			}

			if (!periodData) {
				this.showSnackbar({
					color: "warning",
					text: "No active period found. Please set a period first.",
				});
				return;
			}
			this.kpiData = [];
			this.selectedNode = chartData;
			this.selectedPeriod = periodData;
			this.dialogdetailuser = true;
		},

		async addKpiData() {
			try {
				this.$store.dispatch("setOverlay", true);
				if (!this.selectedPeriod || !this.selectedPeriod.id) {
					this.showSnackbar({
						color: "error",
						icon: "mdi-alert",
						text: "Periode KPI tidak ditemukan",
						title: "Error",
						visible: true,
					});
					return;
				}
				const selectedOwnerId = this.selectedNode.id;
				const payload = {
					kpi_periode_id: this.selectedPeriod.id,
					chart_id: this.selectedNode.id,
					manual_adjustment: false,
					kpi_name: null,
					owner_id: selectedOwnerId,
					sharing_id: null,
					pengukuran: null,
					sumber_data: null,
					unit_id: null,
					kalkulasi_id: null,
					vertical_id: null,
					bobot: null,
					annual_target: null,
					direction: null,
				};
				const response = await this.$axios.post(
					`${process.env.VUE_APP_URL}/api/kpi-item`,
					payload,
					{
						headers: {
							Authorization: `Bearer ${this.$store.getters.isTokenUser}`,
							"Content-Type": "application/json",
						},
					}
				);

				console.log("✅ KPI item created successfully:", response.data);
				this.kpiData.push({
					id: response.data.id,
					kpi_periode_id: this.selectedPeriod.id,
					chart_id: this.selectedNode.id,
					manualAdjustment: false,
					kpiName: "",
					unit: "",
					kalkulasi: "",
					bobot: "",
					status_kpi: "new",
					ownerSets: [
						{
							kpi_item_id: response.data.id,
							owner: selectedOwnerId,
							sharing: "",
							pengukuran: "",
							sumberData: "",
							annualTarget: "",
							higherLower: "",
							checked: false,
						},
					],
				});
				await this.batchSaveAllTableData();
				this.$nextTick(() => {
					this.showSnackbar({
						color: "success",
						icon: "mdi-check-circle",
						text: "KPI item berhasil ditambahkan dan disimpan",
						timeout: 20000,
						title: "Success",
						visible: true,
					});
				});
				await this.$nextTick();
				await new Promise((r) => setTimeout(r, 100));

				await this.$router.replace({
					query: {
						chartId: this.selectedNode.id,
						kpiPeriodeId: this.selectedPeriod.id,
						openDetail: "true",
						newItem: "true",
					},
				});
				this.$store.dispatch("setOverlay", false);
				window.location.reload();
				window.scrollTo({
					top: Math.max(
						0,
						(document.body.scrollHeight - window.innerHeight) / 2
					),
					behavior: "smooth",
				});
			} catch (error) {
				this.$store.dispatch("setOverlay", false);

				this.showSnackbar({
					color: "error",
					icon: "mdi-alert",
					text: error.response?.data?.message || "Gagal menambahkan KPI item",
					timeout: 7500,
					title: "Error",
					visible: true,
				});
			}
		},

		async batchSaveAllTableData() {
			try {
				const batchData = [];
				this.kpiData.forEach((kpi) => {
					if (kpi.id && kpi.ownerSets && kpi.ownerSets.length > 0) {
						const parentOwnerSet = kpi.ownerSets[0];
						const parentKpiData = {
							id: kpi.id,
							manual_adjustment: kpi.manualAdjustment || false,
							kpi_name: kpi.kpiName || null,
							owner_id: parentOwnerSet.owner || null,
							sharing_id: null,
							pengukuran: parentOwnerSet.pengukuran || null,
							sumber_data: parentOwnerSet.sumberData || null,
							unit_id: this.getUnitId(kpi.unit),
							kalkulasi_id: this.getCalculationId(kpi.kalkulasi),
							vertical_id: this.getVerticalId(kpi.vertikal),
							bobot: kpi.bobot || null,
							annual_target: parentOwnerSet.annualTarget || null,
							direction: parentOwnerSet.higherLower || null,
						};

						if (
							kpi.ownerSets[0].sharing &&
							kpi.ownerSets[0].sharing.length > 0
						) {
							parentKpiData.shares = kpi.ownerSets[0].sharing.map((share) => ({
								chart_id: share.value || share.id || share,
							}));
						} else {
							parentKpiData.shares = [];
						}

						console.log(
							`📤 Adding parent KPI ${kpi.id} to batch:`,
							parentKpiData
						);
						batchData.push(parentKpiData);
						if (kpi.ownerSets.length > 1) {
							for (let i = 1; i < kpi.ownerSets.length; i++) {
								const childOwnerSet = kpi.ownerSets[i];
								if (childOwnerSet.kpi_item_id) {
									const childKpiData = {
										id: childOwnerSet.kpi_item_id,
										owner_id: childOwnerSet.owner || null,
										annual_target: childOwnerSet.annualTarget || null,
									};

									if (
										childOwnerSet.sharing &&
										childOwnerSet.sharing.length > 0
									) {
										childKpiData.shares = childOwnerSet.sharing.map(
											(share) => ({
												chart_id: share.value || share.id || share,
											})
										);
									} else {
										childKpiData.shares = [];
									}

									console.log(
										`📤 Adding child KPI ${childOwnerSet.kpi_item_id} to batch (minimal):`,
										childKpiData
									);
									batchData.push(childKpiData);
								}
							}
						}
					}
				});
				const batchPayload = {
					chart_id: this.selectedNode.id,
					items: batchData,
				};
				const response = await this.$axios.post(
					`${process.env.VUE_APP_URL}/api/kpi-item/batch/update`,
					batchPayload,
					{
						headers: {
							Authorization: `Bearer ${this.$store.getters.isTokenUser}`,
							"Content-Type": "application/json",
						},
					}
				);

				console.log("✅ Batch save berhasil:", response.data);
			} catch (error) {
				this.showSnackbar({
					color: "warning",
					icon: "mdi-alert",
					text: "Item berhasil ditambahkan, namun auto-save gagal",
					timeout: 5000,
					title: "Warning",
					visible: true,
				});
			}
		},

		getUnitId(unitText) {
			if (!unitText) return null;

			const unitMap = {
				"%": 1,
				Rp: 2,
				Unit: 3,
			};
			return unitMap[unitText] || null;
		},

		getCalculationId(calcText) {
			if (!calcText) return null;

			const calcMap = {
				Sum: 1,
				Last: 4,
				Max: 3,
				Average: 2,
			};
			return calcMap[calcText] || null;
		},

		getVerticalId(verticalText) {
			if (!verticalText) return null;

			const verticalMap = {
				Sum: 1,
				Average: 2,
			};
			return verticalMap[verticalText] || null;
		},
		async handleChartDetailResponse(response) {
			if (response.data) {
				this.selectedNode = {
					...this.selectedNode,
					...response.data,
					status: response.data.status,
				};
			}
		},
		addOwnerSet({ kpiIndex, newOwnerSet }) {
			if (this.kpiData[kpiIndex]) {
				this.kpiData[kpiIndex].ownerSets.push(newOwnerSet);
			}
		},

		async removeOwnerSet({ kpiIndex, ownerSetIndex, kpiItemId }) {
			if (kpiIndex < 0 || ownerSetIndex <= 0) return;

			const parentKpi = this.kpiData[kpiIndex];
			if (
				!parentKpi ||
				!parentKpi.ownerSets ||
				!parentKpi.ownerSets[ownerSetIndex]
			)
				return;

			try {
				this.$store.dispatch("setOverlay", true);

				const itemIdToDelete =
					kpiItemId || parentKpi.ownerSets[ownerSetIndex].kpi_item_id;
				if (itemIdToDelete) {
					await this.$axios.delete(
						`${process.env.VUE_APP_URL}/api/kpi-item/${itemIdToDelete}`,
						{
							headers: {
								Authorization: `Bearer ${this.$store.getters.isTokenUser}`,
							},
						}
					);
				}
				this.kpiData[kpiIndex].ownerSets.splice(ownerSetIndex, 1);
				if (parentKpi.ownerSets.length <= 1) {
					parentKpi.vertikal = "";
				}
				const hasChildren = parentKpi.ownerSets.length > 1;
				const hasShares =
					Array.isArray(parentKpi.shares) && parentKpi.shares.length > 0;
				this.$set(
					parentKpi,
					"status_kpi",
					hasShares ? "shared" : hasChildren ? "parent" : "owned"
				);
			} catch (error) {
				console.error("Error menghapus owner set:", error);
			} finally {
				this.$store.dispatch("setOverlay", false);
			}
		},
		async removeAllset(indexOrObject) {
			const index =
				typeof indexOrObject === "object"
					? indexOrObject.kpiIndex
					: indexOrObject;
			if (index >= 0 && index < this.kpiData.length) {
				const kpiToDelete = this.kpiData[index];
				this.deleteOwnerSetData = {
					kpiIndex: index,
					kpiName: kpiToDelete.kpiName,
					kpiId: kpiToDelete.id,
				};
				this.deleteConfirmDialog = true;
			} else {
				console.error(
					"Invalid KPI index:",
					index,
					"for array length:",
					this.kpiData.length
				);
			}
		},

		async confirmDeleteKpi() {
			if (!this.deleteOwnerSetData) return;

			const { kpiIndex, kpiId } = this.deleteOwnerSetData;
			const kpiToDelete = this.kpiData[kpiIndex];

			try {
				this.$store.dispatch("setOverlay", true);

				if (kpiId) {
					await this.$axios.delete(
						`${process.env.VUE_APP_URL}/api/kpi-item/${kpiId}`,
						{
							headers: {
								Authorization: `Bearer ${this.$store.getters.isTokenUser}`,
							},
						}
					);

					console.log(
						`✅ KPI dengan ID ${kpiId} berhasil dihapus dari database`
					);
				}

				this.kpiData.splice(kpiIndex, 1);
				console.log(
					"Successfully removed KPI at index:",
					kpiIndex,
					"Remaining KPIs:",
					this.kpiData.length
				);

				this.showSnackbar({
					color: "success",
					icon: "mdi-check-circle",
					text: "KPI berhasil dihapus",
					timeout: 3000,
					title: "Success",
					visible: true,
				});
			} catch (error) {
				console.error("❌ Error deleting KPI:", error);

				this.showSnackbar({
					color: "error",
					icon: "mdi-alert",
					text: error.response?.data?.message || "Gagal menghapus KPI",
					timeout: 7500,
					title: "Error",
					visible: true,
				});
			} finally {
				this.$store.dispatch("setOverlay", false);
				this.deleteOwnerSetData = null;
				this.deleteConfirmDialog = false;
			}
		},
		confirmDeleteOwnerSet() {
			if (!this.deleteOwnerSetData) return;
			const { kpiIndex, ownerSetIndex, kpiItemId } = this.deleteOwnerSetData;
			this.$emit("remove-owner-set", {
				kpiIndex,
				ownerSetIndex,
				kpiItemId,
			});
			this.$emit("show-snackbar", {
				color: "success",
				icon: "mdi-check-circle",
				timeout: 3000,
				title: "Berhasil",
				text: "Child berhasil dihapus",
			});

			this.deleteOwnerSetData = null;
			this.deleteConfirmDialog = false;
		},
		cancelDeleteOwnerSet() {
			this.deleteOwnerSetData = null;
			this.deleteConfirmDialog = false;
		},
		handleRemoveOwnerSet({ kpiIndex, ownerSetIndex }) {
			this.removeOwnerSet(kpiIndex, ownerSetIndex);
		},
		async loadPeriods() {
			this.loadPeriodsFromNode(this.selectedNode);
		},
		loadPeriodsFromNode(node) {
			if (!node?.kpi_periode) {
				this.periodList = [];
				return;
			}
			this.periodList = node.kpi_periode.map((period) => {
				return {
					id: period.id,
					start_date: period.start_month,
					end_date: period.end_month,
					chart_id: period.chart_id,
					user_id: period.user_id,
					status: period.status,
					user: period.user,
				};
			});

			console.log("Final periodList:", this.periodList);
		},
		formatDate(date) {
			if (!date) return "";
			const [year, month] = date.split("-");
			const monthNames = [
				"January",
				"February",
				"March",
				"April",
				"May",
				"June",
				"July",
				"August",
				"September",
				"October",
				"November",
				"December",
			];
			return `${monthNames[parseInt(month) - 1]} ${year}`;
		},
		closeAddPeriodModal() {
			this.showAddPeriodModal = false;
			this.newPeriod = {
				start_month: "",
				end_month: "",
			};
		},
		async addPeriod() {
			if (this.newPeriod.start_month && this.newPeriod.end_month) {
				this.$store.dispatch("setOverlay", true);
				try {
					await new Promise((resolve) => setTimeout(resolve, 1000));
					const payload = {
						start_month: this.newPeriod.start_month,
						end_month: this.newPeriod.end_month,
					};

					const response = await this.$axios.post(
						`${process.env.VUE_APP_URL}/api/kpi-periode`,
						payload,
						{
							headers: {
								Authorization: `Bearer ${this.$store.getters.isTokenUser}`,
								"Content-Type": "application/json",
							},
						}
					);
					this.periodList.push({
						start_date: this.newPeriod.start_month,
						end_date: this.newPeriod.end_month,
						user: this.selectedNode.user,
					});
					await this.loadKpiPeriode();
					this.$emit("snackbar", {
						color: "success",
						icon: "mdi-check-circle",
						timeout: 3000,
						title: "Success",
						text: "Period successfully added",
					});
				} catch (err) {
					console.error("Add period error:", err);
					this.$emit("snackbar", {
						color: "error",
						icon: "mdi-alert-circle",
						timeout: 5000,
						title: "Error",
						text: err.response?.data?.message || "Failed to add period",
					});
				} finally {
					this.$store.dispatch("setOverlay", false);
				}
			}
		},
		validateEndDate() {
			if (this.newPeriod.start_month && this.newPeriod.end_month) {
				return (
					this.newPeriod.start_month < this.newPeriod.end_month ||
					"End date must be after start date"
				);
			}
			return true;
		},
		confirmDeletePeriod(period, index) {
			this.periodToDelete = { ...period, index };
			this.deletePeriodDialog = true;
		},
		async deletePeriodConfirmed() {
			if (!this.periodToDelete) return;

			try {
				this.$store.dispatch("setOverlay", true);
				await this.$axios.delete(
					`${process.env.VUE_APP_URL}/api/kpi-periode/${this.periodToDelete.id}`,
					{
						headers: {
							Authorization: `Bearer ${this.$store.getters.isTokenUser}`,
						},
					}
				);
				this.periodList.splice(this.periodToDelete.index, 1);
				this.deletePeriodDialog = false;
				this.periodToDelete = null;
				this.$emit("snackbar", {
					color: "success",
					icon: "mdi-check-circle",
					timeout: 3000,
					title: "Success",
					text: "Period successfully deleted",
				});
			} catch (err) {
				console.error("Delete period error:", err);
				this.$emit("snackbar", {
					color: "error",
					icon: "mdi-alert-circle",
					timeout: 5000,
					title: "Error",
					text: err.response?.data?.message || "Failed to delete period",
				});
			} finally {
				this.$store.dispatch("setOverlay", false);
			}
		},
		async confirmDelete() {
			this.$store.dispatch("setOverlay", true);
			try {
				const res = await this.$axios.delete(
					`${process.env.VUE_APP_URL}/api/charts/${this.localNode.id}`,
					{
						headers: {
							Authorization: `Bearer ${this.$store.getters.isTokenUser}`,
						},
					}
				);
				this.$emit("snackbar", {
					color: "success",
					icon: "mdi-check-circle",
					timeout: 3000,
					title: "Success",
					text: "User KPI successfully created",
				});
				this.$emit("submitted");
				this.deleteDialog = false;
				setTimeout(() => {
					this.$store.dispatch("setOverlay", false);
					window.location.reload();
				}, 1000);
			} catch (err) {
				this.snackbar = {
					color: "error",
					icon: "mdi-alert",
					title: "Error",
					text: "Delete failed.",
					visible: true,
				};
			}
		},
		async loadKpiPeriode() {
			try {
				this.loadingPeriodeList = true;
				const response = await this.$axios.get(
					`${process.env.VUE_APP_URL}/api/kpi-periode`,
					{
						headers: {
							Authorization: `Bearer ${this.$store.getters.isTokenUser}`,
						},
						params: {
							entity_id: this.entity.id,
						},
					}
				);

				this.periodList = response.data.data;
			} catch (error) {
				this.showSnackbar({
					color: "error",
					text: "Gagal memuat data periode",
				});
			} finally {
				this.loadingPeriodeList = false;
			}
		},
		async setActivePeriode(item) {
			this.$store.dispatch("setOverlay", true);
			try {
				this.loadingSetActive = true;
				await new Promise((resolve) => setTimeout(resolve, 1000));
				const response = await this.$axios.post(
					`${process.env.VUE_APP_URL}/api/kpi-periode/set-active/${item.id}`
				);
				if (response.data.status === "success") {
					this.periodeListData.forEach((periode) => {
						periode.is_active = 0;
					});

					const selectedPeriode = this.periodeListData.find(
						(p) => p.id === item.id
					);
					if (selectedPeriode) {
						selectedPeriode.is_active = 1;
					}

					this.$emit("snackbar", {
						color: "success",
						icon: "mdi-check-circle",
						timeout: 3000,
						text: "Periode berhasil diaktifkan!",
					});
					await this.loadKpiPeriode();
				}
			} catch (error) {
				console.error("Error setting active periode:", error);
				this.$emit("snackbar", {
					color: "error",
					icon: "mdi-alert-circle",
					timeout: 5000,
					text: "Gagal mengaktifkan periode!",
				});
			} finally {
				this.loadingSetActive = false;
				this.$store.dispatch("setOverlay", false);
			}
		},
		openPeriodDialog() {
			this.loadKpiPeriode();
			this.showAddPeriodModal = true;
		},
		async deletePeriodConfirmed() {
			if (!this.periodToDelete) return;

			try {
				this.$store.dispatch("setOverlay", true);
				await this.$axios.delete(
					`${process.env.VUE_APP_URL}/api/kpi-periode/${this.periodToDelete.id}`,
					{
						headers: {
							Authorization: `Bearer ${this.$store.getters.isTokenUser}`,
						},
					}
				);
				await this.loadKpiPeriode();
				this.deletePeriodDialog = false;
				this.periodToDelete = null;
				this.$emit("snackbar", {
					color: "success",
					icon: "mdi-check-circle",
					timeout: 3000,
					title: "Success",
					text: "Period successfully deleted",
				});
			} catch (err) {
				console.error("Delete period error:", err);
				this.$emit("snackbar", {
					color: "error",
					icon: "mdi-alert-circle",
					timeout: 5000,
					title: "Error",
					text: err.response?.data?.message || "Failed to delete period",
				});
			} finally {
				this.$store.dispatch("setOverlay", false);
			}
		},
		async refreshDataAfterEdit() {
			try {
				await this.$store.dispatch("setOverlay", true);
				await this.getAllChartFilters();
				if (this.entity && this.entity.id) {
					await this.loadChartByEntity();
				}
				await this.$store.dispatch("setOverlay", false);
			} catch (error) {
				console.error("❌ Error refreshing data:", error);
				await this.$store.dispatch("setOverlay", false);
				this.showSnackbar({
					color: "error",
					icon: "mdi-alert-circle",
					timeout: 3000,
					title: "Error",
					text: "Failed to refresh data",
				});
			}
		},
		getVerticalText(verticalId) {
			const verticalMap = {
				1: "Sum",
				2: "Average",
			};
			return verticalMap[verticalId] || "";
		},
		deletePeriode(item) {
			const index = this.periodList.findIndex(
				(period) => period.id === item.id
			);
			this.periodToDelete = { ...item, index };
			this.deletePeriodDialog = true;
		},
		handleKpiDeleted(kpiId) {
			const index = this.kpiData.findIndex((kpi) => kpi.id === kpiId);
			if (index !== -1) {
				this.kpiData.splice(index, 1);
				console.log(`KPI dengan ID ${kpiId} berhasil dihapus`);
			}
		},
		async deleteKpiItemById(kpiId) {
			try {
				this.$store.dispatch("setOverlay", true);
				await this.$axios.delete(
					`${process.env.VUE_APP_URL}/api/kpi-item/${kpiId}`,
					{
						headers: {
							Authorization: `Bearer ${this.$store.getters.isTokenUser}`,
						},
					}
				);
				await this.loadKpiData();

				this.$emit("snackbar", {
					color: "success",
					icon: "mdi-check-circle",
					timeout: 3000,
					title: "Success",
					text: "KPI item berhasil dihapus",
				});
			} catch (error) {
				console.error("❌ Error deleting KPI item:", error);

				this.$emit("snackbar", {
					color: "error",
					icon: "mdi-alert-circle",
					timeout: 5000,
					title: "Error",
					text: error.response?.data?.message || "Gagal menghapus KPI item",
				});
			} finally {
				this.$store.dispatch("setOverlay", false);
			}
		},
		convertShares(shares) {
			if (!shares || shares.length === 0) {
				return [];
			}
			if (!this.sharingOptions || this.sharingOptions.length === 0) {
				return shares.map((share) => ({
					text: `Chart ID: ${share.chart_id}`,
					value: share.chart_id,
				}));
			}

			return shares.map((share) => {
				let option = this.sharingOptions.find((opt) => {
					return opt.value == share.chart_id || opt.value === share.chart_id;
				});
				if (!option && this.owners) {
					option = this.owners.find((owner) => {
						return (
							owner.value == share.chart_id || owner.value === share.chart_id
						);
					});
				}
				return {
					text: option ? option.text : `Chart ID: ${share.chart_id}`,
					value: share.chart_id,
				};
			});
		},
	},
};
</script>
<style>
.v-dialog__content.right-modal {
	justify-content: flex-end !important;
	align-items: flex-start !important;
	padding: 0 !important;
	margin: 0 !important;
}
.v-dialog.right-modal {
	position: fixed !important;
	right: 0 !important;
	top: 64px !important;
	bottom: 0 !important;
	left: auto !important;
	margin: 0 !important;
	max-width: 320px !important;
	width: 100% !important;
	display: flex;
	flex-direction: column;
}
.custom-dialog {
	flex: 1 1 auto;
	display: flex;
	flex-direction: column;
	width: 100%;
	border-radius: 8px 0 0 8px;
	overflow: hidden;
}
.scrollable-content {
	flex: 1 1 auto;
	overflow-y: auto;
	padding: 0 16px 16px 16px;
}
.orgchart .node .title {
	font-size: 13px !important;
	background-color: #125a97;
}
#tree {
	padding: 0 !important;
	margin: 0 auto !important;
	text-align: center;
}
.orgchart .lines {
	stroke: #bdbdbd;
	stroke-width: 2px;
}
#tree svg {
	width: 100% !important;
	height: auto !important;
	overflow: visible !important;
}
.orgchart .node .title {
	font-size: 13px !important;
	background-color: #125a97 !important;
}
.orgchart .hidden-root,
.orgchart .bridge-node {
	display: none !important;
}
.orgchart .bridge-node ~ .lines,
.orgchart .hidden-root ~ .lines {
	display: none !important;
}
.orgchart .bridge-node ~ .nodes,
.orgchart .hidden-root ~ .nodes {
	margin-top: 0 !important;
}
.gradient-card {
	background: linear-gradient(145deg, #d74545 0%, #f5f5f5 100%);
	border: 1px solid #e0e0e0;
}
.chart-container {
	background: #ffffff;
	/* Menyesuaikan tinggi layar user (dikurangi app bar + toolbar header)
	   supaya area chart lebih lebar, bukan tinggi tetap 500px. */
	height: calc(100vh - 230px);
	min-height: 420px;
	overflow: hidden;
}
.org-chart-wrapper {
	width: 100%;
	height: 100%;
	transition: all 0.3s ease;
}
/* Plugin OrgChart membuat .orgchart sebesar konten (inline-block), jadi area
   kosong di sekitar tree tidak ikut ter-drag untuk pan — lebarkan supaya
   pan bisa dimulai dari mana saja di dalam wrapper, bukan cuma tepat di chart. */
.org-chart-wrapper .orgchart {
	display: block;
	width: 100%;
	height: 100%;
	min-height: 450px;
}
.v-card {
	transition: all 0.3s ease;
}
.v-card:hover {
	transform: translateY(-2px);
	box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1) !important;
}
.blue-gradient-border {
	position: relative;
}
.blue-gradient-border::before {
	content: "";
	position: absolute;
	left: 0;
	top: 0;
	height: 100%;
	width: 4px;
	background: linear-gradient(180deg, #dee5ec 0%, #64b5f6 100%);
	border-radius: 4px 0 0 4px;
}
.orgchart .node .content {
	margin-bottom: 1px;
	overflow: hidden;
	text-overflow: ellipsis;
}
.orgchart .node.node-green .title {
	background-color: #4caf50 !important;
	color: #fff;
}
.orgchart .node.node-gray .title {
	background-color: #125a97 !important;
	color: #fff;
}
.orgchart .node.node-orange .title {
	background-color: #ff9800 !important;
	color: #fff;
}
.orgchart .node.node-vacant .title {
	color: #f44336 !important;
}
</style>
